export const onResize = () => {
  // if (window.parent === window) {
  //   return;
  // }
  // const sectionContainers = document.querySelectorAll('.section-container');
  // const footer = document.querySelector('footer');
  // if (sectionContainers[0]) {
  //   let height = 0;
  //   sectionContainers.forEach(section => {
  //     height += section.scrollHeight;
  //   });
  //   if (footer) {
  //     height += footer.scrollHeight;
  //   }
  //   const width = sectionContainers[0].scrollWidth;
  //   window.parent.postMessage(
  //     {
  //       type: 'resize',
  //       width,
  //       height,
  //     },
  //     '*',
  //   );
  // }
};

export const onResize2 = () => {
  if (window.parent === window) {
    return;
  }

  const pageContainer = document.querySelector('.page-container');
  const footer = document.querySelector('footer');

  if (pageContainer) {
    // let height = Number(
    //   getComputedStyle(pageContainer).height.replace('px', ''),
    // );
    let height = pageContainer.scrollHeight;
    if (footer) {
      height += footer.scrollHeight;
    }
    const width = pageContainer.scrollWidth;

    console.log('height', height);
    window.parent.postMessage(
      {
        type: 'resize',
        width,
        height,
      },
      '*',
    );
  }
};

export const onIframeScrollIntoView = () => {
  if (window.parent === window) {
    return;
  }
  window.parent.postMessage(
    {
      type: 'load',
    },
    '*',
  );
};

export const getIFrameReferrer = callback => {
  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      type: 'info',
    },
    '*',
  );

  const listener = event => {
    const data = event.data;

    if (data.type != 'info') {
      return;
    }

    callback(data.referrer);

    window.removeEventListener('message', listener);
  };

  window.addEventListener('message', listener);
};

export const getIframeColors = callback => {
  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      type: 'colors',
    },
    '*',
  );

  const listener = event => {
    const data = event.data;

    if (data.type != 'colors') {
      return;
    }

    callback(data.colors);

    window.removeEventListener('message', listener);
  };

  window.addEventListener('message', listener);
};
